import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyCall from "@/components/StickyCall";
import FloatingCall from "@/components/FloatingCall";
import SmoothScroll from "@/components/SmoothScroll";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SmoothScroll>
      <div className="App bg-white text-ink">
        <Header />
        <main className="pb-16 lg:pb-0">
          <Outlet />
        </main>
        <Footer />
        <StickyCall />
        <FloatingCall />
      </div>
    </SmoothScroll>
  );
}
